<template>
	<div class="login-end-hint" v-if="isShowUpgradeHint">
		<div class="login-end-hint-content-image">
			<el-image src="/images/icon_upgrade.png"></el-image>
		</div>
	</div>
</template>

<script>
// import {onGetUpgradeNotice} from '@/util/paramsUtils'

// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// import { mapGetters } from 'vuex'
export default {
	name: 'upgradeClose',
	props: {},
	data() {
		return {
			isShowUpgradeHint: true,
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
	},
	methods: {},
	watch: {},
	created() {},
	mounted() {
		// onGetUpgradeNotice().then((res) => {
		// 	this.isShowUpgradeHint = res
		// })
	},
	updated() {},
	activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
	beforeDestroy() {},
}
</script>

<style scoped lang="scss">
.login-end-hint {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 9999;

	.login-end-hint-content {
		width: 400px;
		height: 200px;
		background-color: #fff;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		border-radius: 10px;

		.login-end-hint-content-title {
			position: absolute;
			top: 10px;
			left: 0;
			width: 100%;
			height: 40px;
			color: #1a1818;
			font-size: 20px;
			font-weight: bold;
			text-align: center;
			line-height: 40px;
			z-index: 1000;
		}
	}

	.login-end-hint-content-image {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.login-end-hint-content-text {
		padding: 10px 20px 0;
		color: #131313;
		font-size: 14px;
		font-weight: bold;
		text-indent: 1em;
		line-height: 26px;
	}
}
</style>
